import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Building2, Lock, User, Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_username", res.data.username);
      toast.success("Login successful");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-slate-900 flex items-center justify-center px-4"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-orange-500 flex items-center justify-center mx-auto mb-3">
            <Building2 className="w-7 h-7 text-white" />
          </div>
          <h1
            className="text-white text-2xl font-bold uppercase"
            style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: "0.05em" }}
          >
            IIE Sigaddi
          </h1>
          <p className="text-orange-400 text-xs font-semibold">VSINDLPARK.COM</p>
          <p className="text-slate-400 text-sm mt-1">Admin Panel</p>
        </div>

        {/* Card */}
        <div className="bg-[#1E293B] border border-white/10 p-8">
          <h2 className="text-white font-bold text-lg mb-6 text-center">Sign In</h2>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">
                <User className="inline w-3.5 h-3.5 mr-1" /> Email / Username
              </label>
              <input
                type="text"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                placeholder="admin"
                required
                className="w-full border border-slate-600 px-3 py-2.5 text-sm focus:outline-none focus:border-orange-500 bg-slate-800 text-white placeholder-slate-500"
                data-testid="admin-username-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">
                <Lock className="inline w-3.5 h-3.5 mr-1" /> Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  required
                  className="w-full border border-slate-600 px-3 py-2.5 pr-10 text-sm focus:outline-none focus:border-orange-500 bg-slate-800 text-white placeholder-slate-500"
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 font-bold uppercase tracking-wider text-sm transition-all duration-300 hover:shadow-[0_0_20px_rgba(249,115,22,0.3)] disabled:opacity-60 mt-2"
              data-testid="admin-login-submit-btn"
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
          <div className="mt-4 p-3 bg-slate-800 border border-white/10 text-xs text-slate-400 text-center">
            Login: admin
          </div>
        </div>

        <p className="text-center text-slate-600 text-xs mt-6">
          <a href="/" className="hover:text-white transition-colors">← Back to Website</a>
        </p>
      </div>
    </div>
  );
}
